import { axiosInstance } from '@/lib/axios'
import {
  CalculateDriversRequestArgs,
  CalculateDriversResponsePayload,
} from './types'

export function requestCalculateDrivers(
  props: CalculateDriversRequestArgs,
) {
  const { companyId } = props
  return axiosInstance.post<CalculateDriversResponsePayload>(
    `/api/${companyId}/timesheet/calculate`,
    props,
  )
}
